<template>
    <user-dashboard-layout>
        <v-row v-if="getOrders">
            <v-col cols="12">
                <v-card>
                    <v-card-title>{{ $t('general.number-of-orders') }}</v-card-title>
                    <v-sparkline
                        :labels="ordersGraph.labels"
                        :value="ordersGraph.values"
                        :gradient="gradient"
                        smooth="1"
                        stroke-linecap="round"
                        line-width="2"
                        padding="16"
                        auto-draw
                    ></v-sparkline>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <loading-component/>
        </v-row>
        <v-row v-if="getOrders">
            <v-col cols="12">
                <v-card>
                    <v-card-title>{{ $t('general.last-10-orders') }}</v-card-title>
                    <v-data-table
                        :items="getData"
                        :headers="headers"
                        hide-default-footer
                    >
                        <template v-slot:header="{ props }">
                            <thead>
                            <tr>
                                <th v-for="header in props.headers" :key="header.text">
                                    {{ $t('general.' + header.text.toLowerCase()) }}
                                </th>
                            </tr>
                            </thead>
                        </template>
                        <template v-for="flag in yesNoColumns" v-slot:[`item.${flag}`]="{ item }">
                            <span :key="flag" :class="{'success--text': item[flag]}">
                                {{ item[flag] ? $t('general.yes') : $t('general.no') }}
                            </span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <loading-component/>
        </v-row>
    </user-dashboard-layout>
</template>

<script>
import UserDashboardLayout from "../../layouts/UserDashboardLayout";
import LoadingComponent from "../../components/ui/loading-component";
import {mapActions, mapGetters} from "vuex";
import {buildOrdersGraph} from "@/utils/ordersGraph";

export default {
    name: "dashboard-index",
    components: {LoadingComponent, UserDashboardLayout},
    data() {
        return {
            guard_table: [
                'id',
                'created_at'
            ],
            gradient: ['#1E5CBA', '#88BA1E'],
            value_for_sparkline: 0,
            yesNoColumns: ['is_printed', 'notified_at', 'is_viewed']
        }
    },
    mounted() {
        this.loadOrders()
    },
    computed: {
        ordersGraph: function () {
            const orders = (this.getOrders && this.getOrders.data) || []
            return buildOrdersGraph(orders.map(order => order.date))
        },
        headers: function () {
            let headers = []
            if (this.getOrders && this.getOrders.data && this.getOrders.data[0]) {
                let keys = Object.keys(this.getOrders.data[0])
                keys.map(el => {
                    if (!this.guard_table.includes(el)) {
                        if (el !== 'details' && el !== 'delivery_type' && el !== 'token' && el !== 'delivery_cost' && el !== 'delivery') {
                            headers.push({
                                text: el,
                                value: el,
                            })
                        }
                    }
                })
            }
            return headers
        },
        getData: function () {
            return this.getOrders.data.map((item) => {
                (item.delivery?.address) ? item.delivery = item.delivery.address : item.delivery = ''
                delete item.pickup_delivery_vending;
                return item;
            });
        },
        ...mapGetters(["getOrders"]),
    },
    methods: {
        ...mapActions(["loadOrders"]),
    }
}
</script>

<style>
thead.v-data-table-header {
    display: none !important;
}

.primary--text g text {
    font-size: 2px;
}
</style>
